import {chain} from 'lodash'
import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import Box from '@mui/material/Box'
import Hidden from '@mui/material/Hidden'
import Fade from '@mui/material/Fade'
import Button from '@mui/material/Button'
import Select from '../../../select'
import TransferList from '../../../transfer-list'
import CheckList from './checklist'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    padding: '0 20px',
    overflow: 'hidden',
  },
  group: {
    padding: '20px 0',
    maxWidth: 'calc(50% - 56px)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'initial'
    }
  },
  students: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto'
  },
  buttons: {
    padding: '20px 0',
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    }
  },
  cancel: {
    width: '120px',
    marginRight: '10px',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      marginRight: '20px',
    }
  },
  continue: {
    width: '120px',
    color: '#fff',
    boxShadow: 'none',
    backgroundColor: '#2ca5ec'
  }
}))

export default function SelectStudents (props) {

  const {selectedGroup, context} = props
  const {groups, translate} = context
  const classes = useStyles()

  const groupOptions = groups.map((group, key) => <option key={key} value={group.id}>{group.name}</option>)
  return (
    <Box className={classes.root}>
      <Box className={classes.group}>
          <label>{translate('group_label')}:</label>
          <Select
            selectValue={selectedGroup}
            selectOnChange={props.onGroupChange}
            controlSize="small"
            controlVariant="outlined"
            controlFullWidth
          >
            {selectedGroup == '' && <option value=""></option>}
            {groupOptions}
          </Select>
      </Box>
      <Box className={classes.students}>
        <Hidden smDown>
          <TransferList
            label={({name}) => name}
            left={props.students} 
            LeftHeader={props => (
              <Box className={classes.studentsHeader}>
                {translate('students')}:
              </Box>
            )}
            RightHeader={props => (
              <Box className={classes.selectedHeader}>
                {translate('selected')}:
              </Box>
            )}
            right={props.selectedStudents} 
            checklist={props.checkedStudents}
            onChecked={props.onStudentsChecked}
            onTransfer={props.onStudentsChange}
          />
        </Hidden>
        <Hidden smUp>
          <CheckList
            items={
              chain(props.students)
              .concat(props.selectedStudents)
              .map(s => ({...s, label: s.alias || s.email}))
              .orderBy(['label', 'id'])
              .value()
            }
            selectAllTitle={translate('students_label')}
            onChecked={props.onStudentsChange}
            checklist={props.selectedStudents.map(s => s.id)}
          />
        </Hidden>
      </Box>
      <Box className={classes.buttons}>
        <Button
          onClick={props.onCancel}
          variant="contained"
          className={classes.cancel}
        >
          {translate('cancel')}
        </Button>
        <Button
          onClick={props.onContinue}
          disabled={props.selectedStudents.length == 0}
          variant="contained"
          className={classes.continue}
        >
          {translate('continue_label')}
        </Button>
      </Box>
    </Box>
  );
}
